import { createSlice } from "@reduxjs/toolkit";
import { getCpaDashoard, getNonRealDashoard, getOwnerDashoard, getSpouseDashoard } from "./_dashboardAction";


interface ManageDashboardState {
  cpaDashoard: {};
  spouseDashoard: {};
  nonRealDashoard: {};
  ownerDashoard: {};
  loading: boolean;
  error: string | null;
}

const initialState: ManageDashboardState = {
  cpaDashoard: {},
  spouseDashoard: {},
  nonRealDashoard: {},
  ownerDashoard: {},
  loading: false,
  error: null,
};


export const dashboardReducer = createSlice({
  name: "dashboard",
  initialState: initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch CPA dashboard 
      .addCase(getCpaDashoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCpaDashoard.fulfilled, (state, action) => {
        state.loading = false;
        state.cpaDashoard = action.payload?.data;
      })
      .addCase(getCpaDashoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Spouse dashoard
      .addCase(getSpouseDashoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getSpouseDashoard.fulfilled, (state, action) => {
        state.loading = false;
        state.spouseDashoard = action.payload?.data;
      })
      .addCase(getSpouseDashoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Non-real dashoard 
      .addCase(getNonRealDashoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getNonRealDashoard.fulfilled, (state, action) => {
        state.loading = false;
        state.nonRealDashoard = action.payload?.data;
      })
      .addCase(getNonRealDashoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      // Fetch Owner dashoard 
      .addCase(getOwnerDashoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOwnerDashoard.fulfilled, (state, action) => {
        state.loading = false;
        state.ownerDashoard = action.payload?.data;
      })
      .addCase(getOwnerDashoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
  },
});


export const { clearError } = dashboardReducer.actions;
export default dashboardReducer;